import React, { useMemo } from 'react';
import './css/index.scss';
import LeftIcon from '../../assets/formIcons/arrowLeft.svg';
import RightIcon from '../../assets/formIcons/arrowRight.svg';

/* function getPagesArray(page, pagesCount = 1) {
  const count = Math.max(1, Math.ceil(pagesCount));
  return Array.from({ length: count }, (_, index) => index + 1);
} */

function getPagesArray(page, pagesCount = 1) {
  const totalVisible = 10;
  const pages = new Set();

  // Всегда включаем первую, последнюю, текущую, предыдущую и следующую
  pages.add(1);
  pages.add(pagesCount);
  pages.add(page);

  if (page > 1) pages.add(page - 1);
  if (page < pagesCount) pages.add(page + 1);

  // Добавим страницы рядом с текущей, пока не наберём 10
  let offset = 2;
  while (pages.size < totalVisible) {
    const before = page - offset;
    const after = page + offset;

    if (before > 1) pages.add(before);
    if (pages.size < totalVisible && after < pagesCount) pages.add(after);

    if (before <= 1 && after >= pagesCount) break;
    offset++;
  }

  const sorted = Array.from(pages).sort((a, b) => a - b);

  // put null where we need "..."
  const result = [];
  for (let i = 0; i < sorted.length; i++) {
    result.push(sorted[i]);
    if (i < sorted.length - 1 && sorted[i + 1] - sorted[i] > 1) {
      result.push(null);
    }
  }

  return result;
}

function TablePagination({ page, setPage, pagesCount }) {
  const arr = useMemo(() => getPagesArray(page, pagesCount), [page, pagesCount]);

  const onLeftClick = () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };

  const onRightClick = () => {
    if (page < pagesCount) {
      setPage(page + 1);
    }
  };

  return (
    <div className="pagination_wrapper">
      <div className="pagination_button pagination_button_left" onClick={onLeftClick}>
        <img src={LeftIcon} alt="" />
      </div>
      <div className="pagination_page_row">
        {arr.map((pageItem, pageItemIndex) => (pageItem === null
          ? <p className="pagination_item_dots" key={`null${pageItemIndex}`}>...</p> : (
            <div
              key={pageItem}
              className={`pagination_item ${pageItem === page ? 'selected' : ''}`}
              onClick={() => setPage(pageItem)}
            >
              {pageItem}
            </div>
          )))}
      </div>

      <div className="pagination_button pagination_button_right" onClick={onRightClick}>
        <img src={RightIcon} alt="" />
      </div>
    </div>
  );
}

export default TablePagination;
